<template>
    <UiContentwrapper class="flex flex-col mt-0 mb-2 pb-1 lg:mt-20 lg:mb-20 lg:pt-2">
               
        <UiFullcolumn v-if="mounted">
                <header>
                    <h2 class="my-0">Partners</h2>
                </header>
                <div class="grid grid-cols-2 md:grid-cols-4 pt-5 gap-7">
                    <div v-for="(article, index) in blog.articles" :key="index">
                        
                        <UiArticleImage :lazy="true" v-if="article.image" :article="article" fit="unset" :width="Number(265)" :height="Number(225)" :sizes="'sm:156px md:225px lg:265px'" />
                    </div>
                </div>                                            
        </UiFullcolumn>

    </UiContentwrapper>
</template>

<script setup>
import { useBlogStore } from '@/stores/blogStore';
var blogStore = useBlogStore();
var blog = ref(null);
var mounted = ref(false);

onMounted(async () => {

    try {
        blog = await blogStore.fetchBlogByHandle('partners');
        mounted.value = true;
    } catch (err) {
        console.error('Error fetching blog data:', err);
    }
});



</script>
